import type { MasterOrderLine } from "~/@types/orderLines";

import { MasterLineItemWithWeeks } from "~/@types/masterOrderWeeks";

const sumWeekQuantities = (lineItem: MasterOrderLine): number =>
	Object.keys(lineItem)
		.filter((key) => key.startsWith("week_") && key.endsWith("_quantity"))
		.reduce(
			(sum, key) => sum + (Number((lineItem as MasterLineItemWithWeeks)[key as `week_${number}_quantity`]) || 0),
			0
		);

export default sumWeekQuantities;
